module.exports = __webpack_public_path__ + "img/portrait_v1.55be499.png";